const menuList = [
  {
    key: 'delivery',
    title: 'Pengiriman',
    desc: 'Mengelola tambahan field untuk transaksi pengiriman.',
    pathName: 'Setting Custom Field Delivery',
    scopes: ['tms:create', 'tms:read', 'tms:update', 'tms:delete'],
  },
  {
    key: 'quick-asssignment',
    title: 'Quick Assignment',
    desc: 'Mengelola tambahan kolom untuk Penugasan Cepat/Quick Assignment',
    pathName: 'Setting Custom Field Quick Assignment',
    scopes: [
      'fleet-task-instant:create',
      'fleet-task-instant:read',
      'fleet-task-instant:update',
      'fleet-task-instant:delete',
    ],
  },
]

export default menuList
